/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Sector from 'galax/server/sector';

import * as Array from 'fierry/util/array';


export default class
{
  constructor (parent, sectors)
  {
    this.collection = new Map();

    for (const sector of sectors.values())
    {
      this.collection.set(sector.id, new Sector(sector, parent));
    }
  }


  setupInstaller (installer)
  {
    for (const sector of this.collection.values())
    {
      sector.setupInstaller(installer);
    }
  }


  getOne (id)
  {
    return this.collection.get(id);
  }


  getAll ()
  {
    return this.collection.values();
  }


  getNeighbors (userID)
  {
    let neighbors = [];

    for (const lhs of this.collection.values())
    {
      if (lhs.getUser().getID() !== userID)
      {
        continue;
      }

      for (const rhs of this.collection.values())
      {
        if (rhs.getUser().getID() === userID)
        {
          continue;
        }

        if (lhs.getNeighbors().isNeighbor(rhs))
        {
          neighbors.push(rhs);
        }
      }
    }

    return Array.unique(neighbors);
  }



}
